const uri = '/webapi/xm/1/settings';

export const GET_PASSWORD_POLICY = 'GET_PASSWORD_POLICY';
export const GET_PASSWORD_POLICY_START = `${GET_PASSWORD_POLICY}_START`;
export const GET_PASSWORD_POLICY_SUCCESS = `${GET_PASSWORD_POLICY}_SUCCESS`;
export const GET_PASSWORD_POLICY_FAIL = `${GET_PASSWORD_POLICY}_FAIL`;

export const getPasswordPolicy = () => {
  const params = {
    embed: 'passwordPolicy',
  };

  return {
    type: GET_PASSWORD_POLICY,
    meta: {
      xmApi: true,
      method: 'get',
      params,
      uri,
    },
  };
};

export const POST_PASSWORD_POLICY = 'POST_PASSWORD_POLICY';
export const POST_PASSWORD_POLICY_START = `${POST_PASSWORD_POLICY}_START`;
export const POST_PASSWORD_POLICY_SUCCESS = `${POST_PASSWORD_POLICY}_SUCCESS`;
export const POST_PASSWORD_POLICY_FAIL = `${POST_PASSWORD_POLICY}_FAIL`;

export const updatePasswordPolicy = policy => ({
  type: POST_PASSWORD_POLICY,
  meta: {
    xmApi: true,
    method: 'post',
    uri: `${uri}`,
    params: policy,
  },
});
